import { render, staticRenderFns } from "./RepositoryUpdate.vue?vue&type=template&id=662917b2&"
import script from "./RepositoryUpdate.vue?vue&type=script&lang=js&"
export * from "./RepositoryUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports